import PropTypes from 'prop-types';
import { Radar, RadarChart, PolarGrid, ResponsiveContainer, Tooltip, PolarRadiusAxis } from 'recharts';

import { SingleValueTooltip } from 'components/charts/SingleValueTooltip';

const CustomizedActiveDot = (props) => {
  const { cx, cy, payload } = props;
  const color = payload?.color;

  return <circle cx={cx} cy={cy} r={8} stroke={color} fill={color} />;
};
const CustomizedDot = (props) => {
  const { cx, cy, payload } = props;
  const color = payload?.payload?.color;

  return <circle cx={cx} cy={cy} r={5} stroke={color} fill={color} />;
};

export const CustomRadarChart = ({ data = [] }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
        <PolarGrid gridType="circle" />
        <PolarRadiusAxis tickCount={8} tick={false} axisLine={false} domain={[0, 7]} />
        <Radar
          dot={<CustomizedDot />}
          activeDot={<CustomizedActiveDot />}
          dataKey="value"
          stroke="#2c2a43"
          strokeWidth="2"
          fill="#8cffea"
          fillOpacity={0.16}
        />
        <Tooltip content={<SingleValueTooltip />} cursor={false} />
      </RadarChart>
    </ResponsiveContainer>
  );
};

CustomRadarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};
